import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'diplomas';

const DiplomaService = {
  getList() {
    return Http.get(`/${RESOURCE_NAME}`);
  },
  getListByStudent() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
  create() {
    return Http.post(`/${RESOURCE_NAME}`);
  },
  del(id) {
    return Http.delete(`/${RESOURCE_NAME}/${id}`);
  },
};

export default DiplomaService;
